/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindAllTasksQueryResponse, FilesControllerFindAllTasksPathParams, FilesControllerFindAllTasksQueryParams, FilesControllerFindAllTasks401, FilesControllerFindAllTasks403, FilesControllerFindAllTasks404 } from "../../models/filesController/FilesControllerFindAllTasks";

function getFilesControllerFindAllTasksUrl(id: FilesControllerFindAllTasksPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/tasks` as const }  
  return res
}

/**
 * @summary List tasks under this file (file scope + descendants)
 * {@link /api/v1/files/:id/tasks}
 */
export async function filesControllerFindAllTasks(id: FilesControllerFindAllTasksPathParams["id"], params?: FilesControllerFindAllTasksQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerFindAllTasksQueryResponse, ResponseErrorConfig<FilesControllerFindAllTasks401 | FilesControllerFindAllTasks403 | FilesControllerFindAllTasks404>, unknown>({ method : "GET", url : getFilesControllerFindAllTasksUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}